<template>

    <v-tooltip top>
      
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab 
               class="transparent"
               @click="onClick"
               depressed
               small
               v-bind="attrs"
               v-on="on">
           
           <v-progress-circular
              :size="30"
              :width="2"
              color="primary"
              indeterminate
              v-if="loading"
            ></v-progress-circular>
           
            <v-img :src="icon"
                    height="30"
                    contain
                    v-else/>

        </v-btn>
      </template>
      
      <span>{{ tooltip }}</span>
    
    </v-tooltip>

</template>

<script>
import Action from '@/models/action'

export default 
{
   name: 'ActionIconBadge',

   mixins: [],

   components: 
   {

   },

   data: () => ({

   }),

   props: {
    action: {
        type: Action,
        required: true
    },
    loading: {
        type: Boolean,
        default: false
    }
   },

   computed: 
   {
    icon()
    {
        if( !this.action.canStart )
            return '/images/icon-waiting.png'

        if( this.action.isCompleted )
            return '/images/icon-completed.png'

        if( this.action.image )
            return this.action.image

        return ''
    },

    iconColor()
    {
        if( this.action.isCompleted )
            return {
                bg: 'green lighten-3',
                icon: 'green'
            }

        return {
                bg: 'gray lighten-3',
                icon: 'primary'
            }
    },

    tooltip()
    {
        if( this.loading )
            return 'Stiamo elaborando la richiesta'

        if( this.action.isCompleted )
            return 'Azione completata'

        if( !this.action.canStart )
            return 'Azione non ancora disponibile'

        return this.action.name
    }

   },

   methods:
   {
    onClick()
    {
        this.$emit('click')
    }
   },

   mounted()
   {

   }
}
</script>